<template>
  <footer>
    <p>© Sam M {{ currYear }}</p>
  </footer>
</template>

<script>
  export default {
    name: 'custom-footer',
    data() {
      return {
        currYear: new Date().getFullYear()
      }
    }
  }
</script>

<style lang="scss" scoped>
  footer {
    width: 100vw;
    padding: 4rem 0 1.5rem 0;
    p {
      display: inline-block;
      margin: 0 auto;
      padding: 0.5rem;
      font-size: 1rem;
      letter-spacing: 1px;
    }
  }
</style>
